module.exports = __webpack_public_path__ + "img/add.a4a00901.svg";